import React, { useState } from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAlert, FDPrimaryActionButton, FDSecondaryActionButton, FDStack,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { dataAttrs } from 'Helpers/Testing';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';

export const GuidedHouseholdReviewOutroForHeadStartLayout = () => {
  const { resource, saving, onSubmit } = useMetaLayoutContext();
  const { loadModalCollectionByLink } = useModalContext();
  const [isLoading, setIsLoading] = useState(false);

  const moreInfoButton = resource.withRelationship(fr.relationships.additionalInformation.name,
    (rel) => (
      <FDSecondaryActionButton
        size="lg"
        {...dataAttrs('roadmap-explorer-investments-more-info-button')}
        label={rel.meta('prompt')}
        onClick={async () => {
          setIsLoading(true);
          try {
            await loadModalCollectionByLink(rel.link('related').url());
          } finally {
            setIsLoading(false);
          }
        }}
        loading={isLoading}
      />
    ),
    () => null);

  return (
    <FDStack direction={'column'} spacing={4} maxWidth="550px" alignSelf={'center'}>
      <FDStack direction={'column'} spacing={3}>
        <MetaControlField attr={'title'} />
        <MetaControlField attr={'description'} />
        <MetaControlField attr={'startNowText'} />
        <MetaControlField attr={'accounts'} />
        <FDAlert description={resource.attr('disclaimer')} />
        <MetaControlField attr="disclosure" />
      </FDStack>
      <FDStack direction={'row'} justifyContent={'center'} spacing={2}>
        <WizardBackButtonRel size="lg" resource={resource} />
        {moreInfoButton}
        <FDPrimaryActionButton
          size="lg"
          {...dataAttrs('submit-btn')}
          loading={saving}
          onClick={onSubmit}
          label={resource.attr('primaryActionLabel')}
          icon="arrowRight"
          iconPosition="end"
        />
      </FDStack>
    </FDStack>
  );
};
